import { render, staticRenderFns } from "./select.vue?vue&type=template&id=2133a7c8"
import script from "./select.vue?vue&type=script&lang=ts"
export * from "./select.vue?vue&type=script&lang=ts"
import style0 from "./select.vue?vue&type=style&index=0&id=2133a7c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports